"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.function.name");
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _configure = require("@/api/configure.js");
var _dictionary = require("@/config/dictionary");
var _index = require("@/utils/index.js");
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'documentManagement',
  data: function data() {
    return {
      name: '',
      //姓名
      committeeValue: '',
      //仲裁委值
      statevalue: '',
      //状态值
      stateArr: [{
        //状态数组
        value: '1',
        label: '已启用'
      }, {
        value: '0',
        label: '已禁用'
      }],
      committeeArr: [],
      loading: true,
      caseBookTemplateType: _dictionary.dictionary.caseBookTemplateType,
      tableData: [],
      total: 0,
      currentPage: 1,
      pageLimit: 10,
      //每页请求多少个数据，默认10
      pageSizes: this.$tablePageSizes,
      documentVisible: false,
      //文书弹窗显示
      title: '',
      //弹窗标题
      docTypeList: [],
      //文书类型
      docForm: {
        //文书数据
        name: '',
        organ: '',
        type: '',
        content: '',
        status: '启用'
      },
      docFormRules: {
        name: [{
          required: true,
          message: '请输入模板名称'
        }],
        organ: [{
          required: true,
          message: '请选择'
        }],
        type: [{
          required: true,
          message: '请选择'
        }],
        content: [{
          required: true,
          message: '请输入'
        }],
        status: [{
          required: true,
          message: '请选择'
        }]
      },
      currentOrganName: '',
      //当前选中仲裁机构名称
      currentTempId: '' //当前选中表格文书id
    };
  },
  created: function created() {
    this.currentPage = 1;
    this.init();
  },
  components: {
    Tinymce: _Tinymce.default
  },
  methods: {
    init: function () {
      var _init = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _this = this;
        var _yield$getcaseBookTem, rows, total;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 查询文书类型
              (0, _configure.getcaseBookTemplateType)({}).then(function (res) {
                if (res.code == 1) {
                  _this.docTypeList = res.data;
                }
              });
              //仲裁委员会列表
              (0, _configure.getAllCommission)().then(function (res) {
                if (res.code == 1) {
                  _this.committeeArr = res.data;
                }
              });
              _context.next = 4;
              return (0, _configure.getcaseBookTemplateList)({
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 4:
              _yield$getcaseBookTem = _context.sent;
              rows = _yield$getcaseBookTem.rows;
              total = _yield$getcaseBookTem.total;
              this.tableData = rows;
              this.total = total;
              this.loading = false;
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }(),
    //重置列表
    resetTableList: function () {
      var _resetTableList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var _yield$getcaseBookTem2, rows, total, _yield$getcaseBookTem3, _rows, _total;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(this.name || this.statevalue || this.committeeValue)) {
                _context2.next = 11;
                break;
              }
              _context2.next = 3;
              return (0, _configure.getcaseBookTemplateList)({
                type: this.name,
                status: this.statevalue,
                commId: this.committeeValue,
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 3:
              _yield$getcaseBookTem2 = _context2.sent;
              rows = _yield$getcaseBookTem2.rows;
              total = _yield$getcaseBookTem2.total;
              this.tableData = rows;
              this.total = total;
              this.loading = false;
              _context2.next = 19;
              break;
            case 11:
              _context2.next = 13;
              return (0, _configure.getcaseBookTemplateList)({
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 13:
              _yield$getcaseBookTem3 = _context2.sent;
              _rows = _yield$getcaseBookTem3.rows;
              _total = _yield$getcaseBookTem3.total;
              this.tableData = _rows;
              this.total = _total;
              this.loading = false;
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function resetTableList() {
        return _resetTableList.apply(this, arguments);
      }
      return resetTableList;
    }(),
    //添加文书
    gotoCreate: function gotoCreate() {
      this.documentVisible = true;
      this.title = "添加文书";
      if (this.$refs['docForm']) {
        this.$refs['docForm'].resetFields();
      }
    },
    //筛选
    screen: function () {
      var _screen = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var _yield$getcaseBookTem4, rows, total;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.total = 1;
              this.currentPage = 1;
              if (!(this.name || this.statevalue || this.committeeValue)) {
                _context3.next = 11;
                break;
              }
              _context3.next = 5;
              return (0, _configure.getcaseBookTemplateList)({
                type: this.name,
                status: this.statevalue,
                commId: this.committeeValue,
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 5:
              _yield$getcaseBookTem4 = _context3.sent;
              rows = _yield$getcaseBookTem4.rows;
              total = _yield$getcaseBookTem4.total;
              this.tableData = rows;
              this.total = total;
              this.loading = false;
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function screen() {
        return _screen.apply(this, arguments);
      }
      return screen;
    }(),
    //点击 清空所有筛选条件
    clearAllConditon: function clearAllConditon() {
      this.statevalue = '';
      this.name = "";
      this.committeeValue = "";
      this.currentPage = 1;
      this.init();
    },
    //表格 删除
    deleteRow: function deleteRow(val) {
      var _this2 = this;
      this.$confirm('是否删除该仲裁机构？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _configure.deleteCaseBookTemplate)({
          id: val.id
        }).then(function (res) {
          if (res.code == 1) {
            _this2.$message({
              message: '删除成功',
              type: 'success'
            });
            _this2.resetTableList();
          }
        });
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //表格 查看并修改
    edit: function edit(val) {
      var _this3 = this;
      this.documentVisible = true;
      this.title = '编辑文书';
      if (this.$refs['docForm']) {
        this.$refs['docForm'].resetFields();
      }
      this.currentTempId = val.id;
      (0, _configure.checkCaseBookTemplate)(val.id).then(function (res) {
        if (res.code == 1) {
          _this3.docForm.name = res.data.templateName;
          _this3.docForm.content = res.data.template;
          _this3.docForm.status = res.data.status == 1 ? '启用' : '禁用';
          _this3.docForm.organ = res.data.commName;
          _this3.docForm.type = _this3.caseBookTemplateType[res.data.type];
        }
      });
    },
    //文书修改/添加提交表单
    submitDocForm: function submitDocForm(formName) {
      var _this4 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var committeeItem = _this4.committeeArr.find(function (ele) {
            return ele.name == _this4.docForm.organ;
          });
          var docTypeItem = _this4.docTypeList.find(function (ele) {
            return ele.desc == _this4.docForm.type;
          });
          if (_this4.title == '添加文书') {
            (0, _configure.addCaseBookTemplate)({
              commName: _this4.docForm.organ,
              templateName: _this4.docForm.name,
              template: _this4.docForm.content,
              type: docTypeItem.type,
              status: _this4.docForm.status == '启用' ? '1' : '0',
              commId: committeeItem.id
            }).then(function (res) {
              if (res.code == 1) {
                _this4.$message({
                  message: '添加文书成功',
                  type: 'success'
                });
                _this4.documentVisible = false;
                _this4.$refs[formName].resetFields();
                _this4.resetTableList();
              }
            });
          } else {
            (0, _configure.updateCaseBookTemplate)({
              commName: _this4.docForm.organ,
              templateName: _this4.docForm.name,
              template: _this4.docForm.content,
              type: docTypeItem.type,
              status: _this4.docForm.status == '启用' ? '1' : '0',
              commId: committeeItem.id,
              id: _this4.currentTempId
            }).then(function (res) {
              if (res.code == 1) {
                _this4.$message({
                  message: '修改文书成功',
                  type: 'success'
                });
                _this4.documentVisible = false;
                _this4.$refs[formName].resetFields();
                _this4.resetTableList();
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    // 分页事件
    handleSizeChange: function handleSizeChange(val) {
      this.pageLimit = val;
      this.resetTableList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.resetTableList();
    }
  }
};
exports.default = _default;